export interface ValidationErrors {
    prefecture?: string
    lastName?: string
    firstName?: string
    phoneNumber?: string
    experience?: string
    situation?: string
    age?: string
    email?: string
    phone?: string
    [key: string]: string | undefined
}

export const MAX_LENGTH = 255
export const PHONE_REGEX = /^(0[6789]0|987)\d{8}$/
